module.exports = __webpack_public_path__ + "static/media/door-1.75e1e2c1.jpg";